import { PhoneCall } from '@salesforce/scv-connector-base';
import { ContactGenerator } from '@main/generators/contact.generator';
import { PhoneCallAttributesGenerator } from '@main/generators/phone-call-attributes.generator';
import { CallInfoGenerator } from '@main/generators/call-info.generator';
import type { CallType } from '@main/types/sf-types';

export class PhoneCallGenerator {
  static generate(
    callId: string,
    callType: CallType,
    phoneNumber: string,
  ): PhoneCall {
    return new PhoneCall({
      callId,
      phoneNumber,
      callType,
      contact: ContactGenerator.generate(phoneNumber),
      callAttributes: PhoneCallAttributesGenerator.generate(),
      callInfo: CallInfoGenerator.generate(callId),
    });
  }
}
